export default {
  controlTowerComexTableHeaders: [
    {
      text: 'processo',
      value: 'processo',
      width: 180,
      tooltip: 'Processos (imp021) - Cadastro de Processos - Código',
    },
    {
      text: 'adquirente',
      value: 'descricaoAdquirente',
      width: 180,
      tooltip: 'Processos (imp021) - Encomendante Adquirente - Código',
    },
    {
      text: 'analista',
      value: 'descricaoAnalista',
      width: 180,
      tooltip: 'Processos (imp021) - Situação - Usuário Responsável',
    },
    {
      text: 'referenciaCliente',
      value: 'referenciaCliente',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'referenciaCliente',
      },
      tooltip: 'Processos (imp021) - Cadastro de Processos - Referência Cliente',
    },
    {
      text: 'dataAberturaProcesso',
      value: 'dataAberturaProcesso',
      width: 220,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataAberturaProcesso',
      },
      tooltip: 'Processos (imp021) - Cadastro de Processos - Datas - Abertura',
    },
    {
      text: 'produto',
      value: 'descricaoProduto',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'descricaoProduto',
      },
      tooltip: 'Processos (imp021) - Cadastro de Processos - III Logística - I Informações Transportadora/Exportador/Importador - Produto',
    },
    {
      text: 'descricaoUnidadeNegocio',
      value: 'descricaoUnidadeNegocio',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'descricaoUnidadeNegocio',
      },
      tooltip: 'Processos (imp021) - Cadastro de Processos - III Logística - I Informações Transportadora/Exportador/Importador - Produto',
    },
    {
      text: 'dataPrevisaoEmbarque',
      value: 'dataPrevisaoEmbarque',
      width: 220,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataPrevisaoEmbarque',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Referências - Datas - Previsão Embarque',
    },
    {
      text: 'dataEmbarque',
      value: 'dataEmbarque',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataEmbarque',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Referências - Datas - Embarque',
    },
    {
      text: 'dataPrevisaoChegada',
      value: 'dataPrevisaoChegada',
      width: 220,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataPrevisaoChegada',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Referências - Datas - Previsão Chegada',
    },
    {
      text: 'dataChegada',
      value: 'dataChegada',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataChegada',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Referências - Datas - Chegada',
    },
    {
      text: 'presencaCarga',
      value: 'presencaCarga',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'presencaCarga',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Referências - Datas - Presença de Carga',
    },
    {
      text: 'descricaoLivreProcesso',
      value: 'descricaoLivreProcesso',
      width: 180,
      tooltip: 'Processos (imp021) - Cadastro de Processos - I Observação - Descrição do Processo',
    },
    {
      text: 'documentosOriginais',
      value: 'dataRecebimentoDocumentosOriginais',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataRecebimentoDocumentosOriginais',
      },
      tooltip: 'Evento "DOCUMENTOS ORIGINAIS RECEBIDOS, SALVOS NO GED" emitido para o processo',
    },
    {
      text: 'provisionamentoCambio',
      value: 'provisionamentoCambio',
      width: 280,
      tooltip: 'Financeiro a Pagar (Automático) - Tipo Documento = FECTH DE CAMBIO IMPORTAÇÃO T E',
    },
    {
      text: 'numerarioConexos',
      value: 'numerario',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'numerario',
      },
    },
    {
      text: 'remocaoArmazem',
      value: 'remocaoArmazem',
      width: 180,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'Sim',
          'Não',
        ],
        field: 'remocaoArmazem',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Containers - Remoção/Retirada - Data Solicitação',
    },
    {
      text: 'desova',
      value: 'desova',
      width: 180,
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Transporte - Cadastro - Forma Nacionalização',
    },
    {
      text: 'dataDesova',
      value: 'dataDesova',
      width: 180,
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Containers - Desova - Data Desova',
    },
    {
      text: 'armazem',
      value: 'descricaoArmazem',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'descricaoArmazem',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Transporte - Cadastro - Pessoas/Entidades - Armazém Desembaraço',
    },
    {
      text: 'bl',
      value: 'numeroBl',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'numeroBl',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Transporte - Cadastro - Número House',
    },
    {
      text: 'recebimentoBlOriginal',
      value: 'recebimentoBlOriginal',
      width: 220,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'recebimentoBlOriginal',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Transporte - Data Recebimento BL',
    },
    {
      text: 'agenteCarga',
      value: 'descricaoAgenteCarga',
      width: 180,
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Transporte - Cadastro - Pessoas/Entidades - Agente',
    },
    {
      text: 'dataLiberacaoSiscarga',
      value: 'dataLiberacaoSiscarga',
      width: 180,
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Referências - Datas - Liberação Siscarga',
    },
    {
      text: 'quantidadeContainer',
      value: 'quantidadeContainer',
      width: 220,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'quantidadeContainer',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Containers (Contagem)',
    },
    {
      text: 'containers',
      value: 'containers',
      width: 180,
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Containers',
    },
    {
      text: 'ce',
      value: 'ce',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'ce',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Transporte - Cadastro - Número CE',
    },
    {
      text: 'navio',
      value: 'navio',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'navio',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Transporte - Cadastro - Referências - Navio',
    },
    {
      text: 'porto',
      value: 'porto',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'porto',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Transporte - Cadastro - Localidades - Destino',
    },
    {
      text: 'dataLiberacaoMapa',
      value: 'dataLiberacaoMapa',
      width: 180,
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Referências - Datas - Data Liberação Mapa',
    },
    {
      text: 'dataVistoriaMapa',
      value: 'dataVistoriaMapa',
      width: 180,
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Referências - Datas - Data Vistoria Mapa',
    },
    {
      text: 'necessitaLi',
      value: 'necessitaLi',
      width: 180,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'Sim',
          'Não',
        ],
        field: 'necessitaLi',
      },
    },
    {
      text: 'li',
      value: 'codigoLi',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'codigoLi',
      },
      tooltip: 'Licenciamento de Importação (log013) - N da LI',
    },
    {
      text: 'dataRegistroLi',
      value: 'dataRegistroLi',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataRegistroLi',
      },
      tooltip: 'Licenciamento de Importação (log013) - Capa - Declaração - Código',
    },
    {
      text: 'orgaoAnuente',
      value: 'orgao',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'orgao',
      },
      tooltip: 'Licenciamento de Importação (log013) - Anuências - Código',
    },
    {
      text: 'statusLi',
      value: 'descricaoStatusLi',
      width: 180,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'Para Análise',
          'Em Análise',
          'Em Exigência',
          'Indeferido',
          'Deferido',
          'Cancelado',
          'Embarque Autorizado',
          'Sem Status',
        ],
        field: 'descricaoStatusLi',
      },
      tooltip: 'Licenciamento de Importação (log013) - Anuências - Situação',
    },
    {
      text: 'deferimentoLi',
      value: 'dataDeferimentoLi',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataDeferimentoLi',
      },
      tooltip: 'Licenciamento de Importação (log013) - Data Deferimento',
    },
    {
      text: 'dataRegistroDi',
      value: 'dataRegistroDi',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataRegistroDi',
      },
      tooltip: 'Cadastro de DI/DSI (imp019) - Capa - Propriedades - Data Registro',
    },
    {
      text: 'di',
      value: 'numeroDi',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'numeroDi',
      },
      tooltip: 'Cadastro de DI/DSI (imp019) - Capa - Declaração - Código',
    },
    {
      text: 'canal',
      value: 'descricaoCanal',
      width: 180,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'Sem Parametrização',
          'Verde',
          'Amarelo',
          'Cinza',
          'Vermelho',
        ],
        field: 'descricaoCanal',
      },
      tooltip: 'Cadastro de DI/DSI (imp019) - Capa - Canal - Descrição',
    },
    {
      text: 'desembaraco',
      value: 'desembaraco',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'desembaraco',
      },
      tooltip: 'Cadastro de DI/DSI (imp019) - Capa - Canal - Data',
    },
    {
      text: 'liberacaoComex',
      value: 'dataLiberacaoComex',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataLiberacaoComex',
      },
      tooltip: 'Processos (imp021) - III Logística - I Informações Transportadora/Exportador/Importador - Data Solicitação do Carregamento',
    },
    {
      text: 'transportadora',
      value: 'descricaoTransportadora',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'descricaoTransportadora',
      },
      tooltip: 'Processos (imp021) - III Logística - I Informações Transportadora/Exportador/Importador - Transportadora (Saída)',
    },
    {
      text: 'carregamento',
      value: 'dataCarregamento',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataCarregamento',
      },
      tooltip: 'Processos (imp021) - III Logística - I Informações Transportadora/Exportador/Importador - Data Execução do Carregamento',
    },
    {
      text: 'ric',
      value: 'ric',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'ric',
      },
      tooltip: 'Lista de documentos dentro da pasta RIC no GED dos processos',
    },
    {
      text: 'freeTime',
      value: 'freeTime',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'freeTime',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Containers - Container - Free Time',
    },
    {
      text: 'vencimentoFreeTime',
      value: 'vencimentoFreeTime',
      width: 220,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'vencimentoFreeTime',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Containers - Container - Data Vencimento Free Time',
    },
    {
      text: 'terminalDevolucao',
      value: 'terminalDevolucao',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'terminalDevolucao',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Containers - Container - Entrega - Terminal de Devolução',
    },
    {
      text: 'demurrage',
      value: 'demurrage',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'demurrage',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Containers - Container - Demurrage',
    },
    // {
    //   text: 'envioFechamento',
    //   value: 'envioFechamento',
    //   width: 220,
    //   filterable: true,
    //   filterComponent: 'DateFilter',
    //   isDataTable: true,
    //   filterParams: {
    //     field: 'envioFechamento',
    //   },
    //   tooltip: 'Evento "ENVIO FECHAMENTO OPERACIONAL" emitido para o processo',
    // },
    {
      text: 'devolucaoVazio',
      value: 'devolucaoVazio',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'devolucaoVazio',
      },
      tooltip: 'Conhecimento de Transporte de Importação (log012) - Containers - Entrega - Data Entrega',
    },
  ],
  controlTowerComexTableItens: [],
  analistasProcessos: [],
  filtros: {
    termo: '',
    page: 1,
    perPage: 20,
    order: 'dataChegada',
    direcao: 'ASC',

    processo: '',
    descricaoAdquirente: '',
    descricaoAnalista: '',
    referenciaCliente: '',
    dataAberturaProcesso: '',
    descricaoProduto: '',
    descricaoLivreProcesso: '',
    dataRecebimentoDocumentosOriginais: '',
    provisionamentoCambio: '',
    numerario: '',
    dataPrevisaoEmbarque: '',
    dataEmbarque: '',
    dataPrevisaoChegada: '',
    dataChegada: '',
    remocaoArmazem: '',
    desova: '',
    dataDesova: '',
    descricaoArmazem: '',
    numeroBl: '',
    recebimentoBlOriginal: '',
    descricaoAgenteCarga: '',
    dataLiberacaoSiscarga: '',
    quantidadeContainer: '',
    containers: '',
    ce: '',
    navio: '',
    porto: '',
    presencaCarga: '',
    dataLiberacaoMapa: '',
    dataVistoriaMapa: '',
    necessitaLi: '',
    codigoLi: '',
    dataRegistroLi: '',
    orgao: '',
    descricaoStatusLi: '',
    dataDeferimentoLi: '',
    dataRegistroDi: '',
    numeroDi: '',
    descricaoCanal: '',
    desembaraco: '',
    dataLiberacaoComex: '',
    descricaoTransportadora: '',
    dataCarregamento: '',
    ric: '',
    freeTime: '',
    vendimentoFreeTime: '',
    terminalDevolucao: '',
    lavacao: '',
    demurrage: '',
    envioFechamento: '',
    devolucaoVazio: '',
  },
};
